import { MapPin, Phone } from "lucide-react";
import { motion } from "framer-motion";
import logo from "../assets/logo.svg";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export default function Footer() {
  return (
    <footer className="bg-primary-dark text-white relative overflow-hidden">
      {/* Organic wave top separator */}
      <svg
        viewBox="0 0 1440 80"
        className="w-full block -mb-px"
        preserveAspectRatio="none"
        style={{ height: "5rem", background: "var(--color-sand)" }}
      >
        <path
          d="M0,40 C360,80 720,0 1080,40 C1260,60 1380,50 1440,40 L1440,80 L0,80 Z"
          fill="var(--color-primary-dark)"
        />
      </svg>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-10 pb-8 relative z-10">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          variants={{
            hidden: {},
            visible: { transition: { staggerChildren: 0.12 } },
          }}
        >
          {/* Brand */}
          <motion.div variants={fadeUp} transition={{ duration: 0.4, ease: "easeOut" }}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center shadow-lg shadow-accent/20">
                <img className="w-8 h-8" src={logo} alt="" />
              </div>
              <div>
                <span className="font-heading text-2xl font-bold text-white block leading-none">
                  El Verde
                </span>
                <span className="text-[10px] text-white/50 font-semibold tracking-[0.2em] uppercase">
                  Comida Costeña
                </span>
              </div>
            </div>
            <p className="text-white/55 text-sm leading-relaxed max-w-xs">
              Comida costeña ecuatoriana en Cuenca. Caldos de bolas,
              encebollados, ceviches y mariscos frescos desde el Pacífico.
            </p>
          </motion.div>

          {/* Contact */}
          <motion.div variants={fadeUp} transition={{ duration: 0.4, ease: "easeOut" }}>
            <h3 className="font-heading text-lg font-semibold text-accent mb-5 flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-accent/15 flex items-center justify-center">
                <MapPin className="w-4 h-4 text-accent" />
              </div>
              Contáctanos
            </h3>
            <address className="not-italic space-y-4 text-sm text-white/70">
              <div>
                <h4 className="text-white font-semibold mb-2.5">
                  Local Ordóñez Lasso
                </h4>
                <p className="flex items-start gap-2.5 mb-2.5">
                  <MapPin className="w-4 h-4 mt-0.5 text-accent/70 shrink-0" />
                  <span>Ordóñez Lasso y Arrayanes, Cuenca, Ecuador</span>
                </p>
                <a
                  href="tel:+593983423290"
                  className="flex items-center gap-2.5 hover:text-white transition-colors font-medium py-1"
                >
                  <Phone className="w-4 h-4 text-accent/70 shrink-0" />
                  +593 98 342 3290
                </a>
              </div>
              <div>
                <h4 className="text-white font-semibold mb-2.5">
                  Local 10 De Agosto
                </h4>
                <p className="flex items-start gap-2.5 mb-2.5">
                  <MapPin className="w-4 h-4 mt-0.5 text-accent/70 shrink-0" />
                  <span>10 de Agosto y Sangurima, Cuenca, Ecuador</span>
                </p>
                <a
                  href="tel:+593983423222"
                  className="flex items-center gap-2.5 hover:text-white transition-colors font-medium py-1"
                >
                  <Phone className="w-4 h-4 text-accent/70 shrink-0" />
                  +593 98 342 3222
                </a>
              </div>
            </address>
          </motion.div>
        </motion.div>

        <motion.div
          className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/35"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.3 }}
        >
          <p>
            © {new Date().getFullYear()} El Verde Restaurante. Todos los
            derechos reservados.
          </p>
          <p>Precios en dólares americanos (USD) e incluyen IVA.</p>
          <p>
            Desarrollado por{" "}
            <a
              href="https://marketherec.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent hover:text-accent/80 transition-colors font-medium"
            >
              Markether
            </a>
          </p>
        </motion.div>
      </div>
    </footer>
  );
}
